// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-b_bO","advertCardFooter__row":"c-b_bP","advertCardFooter__name":"c-b_bQ","advertCardFooter__price":"c-b_bR","advertCardFooter__age":"c-b_bS"};